import React from 'react';
import DimensionTableCell from './DimensionTableCell';

const DimensionTable = ({ data }) => {
    return (
        <div className="table-responsive-material">
            <table className="default-table table-unbordered table table-hover">
                <thead className="th-border-b">
                    <tr>
                        <th>Dimension</th>
                        <th>Question</th>
                        <th>
                            <div className="media project-list">
                                <span className="circle-shape bg-red"></span>
                                <div className="media-body">% neg perception</div>
                                <span className="circle-shape bg-orange"></span>
                                <div className="media-body">% neg hesitance</div>
                                <span className="circle-shape bg-blue"></span>
                                <div className="media-body">% pos hesitance</div>
                                <span className="circle-shape bg-green"></span>
                                <div className="media-body">% pos perception</div>
                            </div>
                        </th>
                        <th>Shift</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(data) ? (
                        data.map((data) => {
                            return <DimensionTableCell key={data.id} data={data} />;
                        })
                    ) : (
                        <React.Fragment></React.Fragment>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default DimensionTable;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/DimensionTable.js